// import Vue from 'vue'
import axios from 'axios'
import router from '../../router'
import store from '../../store/index'
// import ElementUI from 'element-ui'
import { Message } from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'

// Vue.use(ElementUI, { size: 'small', zIndex: 2000 })
// Vue.prototype.$message = Message
// 创建axios实例
var instance = axios.create({ timeout: 1000 * 60 * 3 })
// axios.defaults.timeout = 10000 // 响应时间

// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/json'
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8' // 配置

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
// const messageWarningTip = msg => {
//   Message.warning({ showClose: true, message: msg })
// }

const messageErrorTip = msg => {
  Message.error({
    showClose: true,
    message: msg,
    dangerouslyUseHTMLString: true,
    customClass: 'custom_message'
  })
}

const messageWarningTip = msg => {
  Message.warning({
    showClose: true,
    message: msg,
    dangerouslyUseHTMLString: true,
    customClass: 'custom_message'
  })
}

/**
 * 跳转登录页
 * 携带当前页面路由，以期在登录页面完成登录后返回当前页面
 */
const toLogin = () => {
  router.push({
    name: 'login', params: { loginType: 'signIn' }, query: { redirect: router.currentRoute.fullPath }
  })
}

// http request 请求拦截器
instance.interceptors.request.use((config) => {
  // let token = window.localStorage.getItem('token')
  const token = store.state.token
  // 在发送请求之前做些什么，加入token
  // 判断是否存在token，如果存在的话，则每个http header都加上token
  if (token) {
    // config.headers.Authorization = token
    config.headers.common.Authorization = 'Bearer ' + token
    // config.headers.common['Authorization'] = 'Bearer ' + token
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// http response 响应拦截器
instance.interceptors.response.use(response => {
  // return response
  // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
  // 否则的话抛出错误
  if (response.status === 200 || response.status === 204) {
    return Promise.resolve(response.data)
  } else {
    return Promise.reject(response.data)
  }
},
error => {
  if (error.response) {
    switch (error.response.status) {
      case 401:
        // 401: 未登录
        // 未登录则清除token信息并跳转到登录页面，并携带当前页面的路径
        // 在登录成功后返回当前页面，返回需要在登录页操作
        messageErrorTip('检测到无授权访问，请先登录')
        // store.commit('REMOVE_ACCOUNT')
        toLogin()
        break

      case 403:
        messageErrorTip('服务器拒绝处理，请联系管理员')
        // 清除token
        // localStorage.removeItem('token')
        // store.commit('REMOVE_ACCOUNT')
        // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
        // setTimeout(() => {
        //   toLogin()
        // }, 1000)
        break

      // 404请求不存在
      case 404:
        messageErrorTip('请求的资源不存在')
        break
      // 601后台自定义信息
      case 601:
        messageWarningTip(error.response.data)
        break
      // 602后台验证信息
      case 602:
        messageWarningTip(error.response.data.Message)
        break
      default:
        if (error.response) {
          if (error.response.statusText === 'customError') {
            messageWarningTip(error.response.data)
          } else if (error.response.statusText === 'modelStateError') {
            messageWarningTip(error.response.data.Message)
          } else if (error.response.data) {
            if (error.response.data.error && error.response.data.error === 'invalid_grant') {
              messageErrorTip(error.response.data.error_description)
            } else {
              if (error.response.status === 400) {
                messageWarningTip(error.response.data.Message)
              } else {
                messageErrorTip('请求错误，请联系客服')
              }
            }
          } else {
            messageErrorTip('请求错误，请联系客服')
          }
        } else {
          messageErrorTip('请求错误，请联系客服')
        }
    }
    return Promise.reject(error.response) // 返回接口返回的错误信息
  } else {
    // 处理断网的情况
    // eg:请求超时或断网时，更新state的network状态
    // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
    // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
    // store.commit('changeNetwork', false);
    messageErrorTip('系统开小差了，请稍后再试')
    window.console.log(error)
    return Promise.reject(error.response)
  }
})

export default instance
